"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonolithApiMediaStrategy = void 0;
var MediaItem_1 = require("../MediaItem");
var MediaStrategy_1 = require("./MediaStrategy");
var __1 = require("../../..");
var sleep_1 = require("../sleep");
var round_1 = require("../round");
var PROCESSING_POLLING_INTERVAL = 1000;
var ERROR_TOAST_DURATION = 5000;
var MonolithApiMediaStrategy = /** @class */ (function (_super) {
    __extends(MonolithApiMediaStrategy, _super);
    function MonolithApiMediaStrategy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.monolithApi = null;
        return _this;
    }
    MonolithApiMediaStrategy.prototype.api = function () {
        if (this.monolithApi === null)
            this.monolithApi = new __1.ApiClient();
        return this.monolithApi;
    };
    MonolithApiMediaStrategy.prototype.handleError = function (error) {
        var _a, _b, _c, _d;
        var errorMessage = this._js('An unknown error occurred, please refresh the page and try again');
        var errorDescription = null;
        if (__1.ApiClient.isApiError(error)) {
            var data = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
            errorMessage = (_d = (_b = data === null || data === void 0 ? void 0 : data.message) !== null && _b !== void 0 ? _b : (_c = data === null || data === void 0 ? void 0 : data.error) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : errorMessage;
            errorDescription = this._js('Please refresh the page and try again');
        }
        if (typeof error === 'string') {
            errorMessage = error;
            errorDescription = this._js('Please refresh the page and try again');
        }
        if (!this.toast.isActive('media-manager-api-error')) {
            this.toast({
                id: 'media-manager-api-error',
                title: errorMessage,
                description: errorDescription,
                status: 'error',
                isClosable: true,
                duration: ERROR_TOAST_DURATION,
                position: 'top',
            });
        }
    };
    MonolithApiMediaStrategy.prototype.get = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var result, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (_a = this.api()).get.apply(_a, args)];
                    case 1:
                        result = _b.sent();
                        if (result.data.error) {
                            this.handleError(result.data.error);
                            throw result.data.error;
                        }
                        return [2 /*return*/, result];
                    case 2:
                        err_1 = _b.sent();
                        this.handleError(err_1);
                        throw err_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.post = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var result, err_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (_a = this.api()).post.apply(_a, args)];
                    case 1:
                        result = _b.sent();
                        if (result.data.error) {
                            this.handleError(result.data.error);
                            throw result.data.error;
                        }
                        return [2 /*return*/, result];
                    case 2:
                        err_2 = _b.sent();
                        this.handleError(err_2);
                        throw err_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.delete = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var result, err_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (_a = this.api()).delete.apply(_a, args)];
                    case 1:
                        result = _b.sent();
                        if (result.data.error) {
                            this.handleError(result.data.error);
                            throw result.data.error;
                        }
                        return [2 /*return*/, result];
                    case 2:
                        err_3 = _b.sent();
                        this.handleError(err_3);
                        throw err_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.handleLoadMediaItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get("/user/media/current", {
                            params: {
                                mediaItemFilterName: this.filter,
                            },
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data.items];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.handleLoadMediaItem = function (type, id) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get("/user/media/".concat(type, "/").concat(id))];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data.item];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.handleLoadImageDetails = function (imageid) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get("/media/images/".concat(imageid), {
                            params: {
                                mediaItemFilterName: this.filter,
                            },
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.handleLoadMediaConstraints = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get('/user/media/constraints', {
                            params: {
                                mediaItemFilterName: this.filter,
                            },
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.data];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.handleAllMediaItemsDeleted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post("/user/media/bulk/delete", {
                            media: this.mediaItems.map(function (item) { return ({
                                mediaType: item.type,
                                itemId: _this.getMediaItemId(item),
                            }); }),
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.handleUpload = function (tempId, file, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var result, mediaItem, readyMediaItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post("/user/media/uploads?file=".concat(file.name), file, {
                            headers: { 'Content-Type': 'application/octet-stream' },
                            onUploadProgress: function (progress) {
                                var _a;
                                onProgress(tempId, {
                                    tempId: tempId,
                                    type: 'Uploading',
                                    step: 'uploading',
                                    progress: (0, round_1.round)(progress.loaded / ((_a = progress.total) !== null && _a !== void 0 ? _a : 0), 2),
                                    file: file,
                                });
                            },
                        })];
                    case 1:
                        result = _a.sent();
                        mediaItem = result.data.details;
                        onProgress(tempId, { tempId: tempId, type: 'Uploading', step: 'processing', progress: null, file: file });
                        return [4 /*yield*/, this.pollForMediaItemReadiness(mediaItem)];
                    case 2:
                        readyMediaItem = _a.sent();
                        onProgress(tempId, readyMediaItem);
                        return [2 /*return*/];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.handleEditedImageUpload = function (tempId, data, file, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var formData, result, mediaItem, readyMediaItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formData = new FormData();
                        formData.append('file', file);
                        formData.append('json', JSON.stringify(data));
                        return [4 /*yield*/, this.post("/user/media/images/edits", formData, {
                                headers: { 'Content-Type': 'multipart/form-data' },
                                onUploadProgress: function (progress) {
                                    var _a;
                                    onProgress(tempId, {
                                        tempId: tempId,
                                        type: 'Uploading',
                                        step: 'uploading',
                                        progress: (0, round_1.round)(progress.loaded / ((_a = progress.total) !== null && _a !== void 0 ? _a : 0), 2),
                                        file: file,
                                    });
                                },
                            })];
                    case 1:
                        result = _a.sent();
                        mediaItem = result.data;
                        onProgress(tempId, { tempId: tempId, type: 'Uploading', step: 'processing', progress: null, file: file });
                        return [4 /*yield*/, this.pollForMediaItemReadiness(mediaItem)];
                    case 2:
                        readyMediaItem = _a.sent();
                        onProgress(tempId, readyMediaItem);
                        return [2 /*return*/, mediaItem];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.handleMediaItemDeleted = function (mediaItem) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.delete("/user/media/".concat(mediaItem.type, "/").concat(this.getMediaItemId(mediaItem)))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.handleCopyMediaItem = function (mediaItem) {
        return __awaiter(this, void 0, void 0, function () {
            var mediaTypeParamFromType, mediaItems;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mediaTypeParamFromType = function (type) {
                            if ((0, MediaItem_1.isGuideImage)(mediaItem)) {
                                return 'image';
                            }
                            else if ((0, MediaItem_1.isGuideVideoObject)(mediaItem)) {
                                return 'video';
                            }
                            else if ((0, MediaItem_1.isGuideEmbedObject)(mediaItem)) {
                                return 'embed';
                            }
                            return mediaItem.type;
                        };
                        return [4 /*yield*/, this.post("/user/media/copies/", {
                                id: this.getMediaItemId(mediaItem),
                                type: mediaTypeParamFromType(mediaItem.type),
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.handleLoadMediaItems()];
                    case 2:
                        mediaItems = _a.sent();
                        this.setState(function (state) { return (__assign(__assign({}, state), { mediaItems: mediaItems })); });
                        return [2 /*return*/];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.handleImportImageByUrl = function (tempId, url, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var result, mediaItem, readyMediaItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post("/user/media/imports/image", { url: url })];
                    case 1:
                        result = _a.sent();
                        mediaItem = result.data;
                        onProgress(tempId, { tempId: tempId, type: 'Uploading', step: 'processing', progress: null });
                        return [4 /*yield*/, this.pollForMediaItemReadiness(mediaItem)];
                    case 2:
                        readyMediaItem = _a.sent();
                        onProgress(tempId, readyMediaItem);
                        return [2 /*return*/];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.handleImportEmbedByUrl = function (tempId, url, onProgress) {
        return __awaiter(this, void 0, void 0, function () {
            var result, mediaItem, readyMediaItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post("/user/media/embeds", { url: url })];
                    case 1:
                        result = _a.sent();
                        mediaItem = result.data;
                        onProgress(tempId, { tempId: tempId, type: 'Uploading', step: 'processing', progress: null });
                        return [4 /*yield*/, this.pollForMediaItemReadiness(mediaItem)];
                    case 2:
                        readyMediaItem = _a.sent();
                        onProgress(tempId, readyMediaItem);
                        return [2 /*return*/];
                }
            });
        });
    };
    MonolithApiMediaStrategy.prototype.pollForMediaItemReadiness = function (mediaItem) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!true) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.get("/user/media/".concat(mediaItem.type, "/").concat(this.getMediaItemId(mediaItem)), {
                                params: {
                                    mediaItemFilterName: this.filter,
                                },
                            })];
                    case 1:
                        result = _a.sent();
                        if (result.data.isReady)
                            return [2 /*return*/, result.data.item];
                        return [4 /*yield*/, (0, sleep_1.sleep)(PROCESSING_POLLING_INTERVAL)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 0];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return MonolithApiMediaStrategy;
}(MediaStrategy_1.MediaStrategy));
exports.MonolithApiMediaStrategy = MonolithApiMediaStrategy;
